import MenuItem from "@mui/material/MenuItem";
import { type SelectProps as SelectPropsMui } from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import { isEmpty } from "lodash";
import { FC, ReactNode } from "react";
import { useController, useFormContext } from "react-hook-form";
import * as StyledCommon from "./Common.styled";
import { FormError } from "./FormError";
import * as Styled from "./SelectInput.styled";

export type SelectInputProps = Omit<SelectPropsMui, "name"> & {
    name: string;
    disabled?: boolean;
    label?: React.ReactNode;
    isRequired?: boolean;
    sublabel?: string;
    LabelComponent?: React.ElementType;
    WrapperComponent?: React.ElementType;
    children: ReactNode;
};

export const SelectInput: FC<SelectInputProps> = ({
    name,
    disabled = false,
    label,
    sublabel,
    isRequired = false,
    LabelComponent = "label",
    WrapperComponent = Stack,
    children,
    ...rest
}) => {
    const { control } = useFormContext();
    const { field, fieldState } = useController({ name, control });
    const { error } = fieldState;

    return (
        <WrapperComponent>
            {!isEmpty(label) && (
                <LabelComponent htmlFor={`${name}-select`}>
                    <StyledCommon.InputLabel>{label}</StyledCommon.InputLabel>
                </LabelComponent>
            )}
            {!isEmpty(sublabel) && <StyledCommon.InputSubLabel>{sublabel}</StyledCommon.InputSubLabel>}
            <Styled.Select
                {...field}
                id={`${name}-select`}
                disabled={disabled}
                error={!!error}
                required={isRequired}
                displayEmpty
                {...rest}
            >
                {children}
            </Styled.Select>
            <FormError error={error} fieldName={name} />
        </WrapperComponent>
    );
};

export { MenuItem as SelectMenuItem };
